export const toRootAssetUrl = (assetPath: string) => {
  const base = process.env.PUBLIC_URL || "";
  return `${base}${assetPath}`;
};

export const toRootAssetUrlWithVersion = (assetPath: string, version = "2") => {
  return `${toRootAssetUrl(assetPath)}?v=${version}`;
};

export const swapJpegJpg = (assetPath: string) => {
  if (assetPath.endsWith(".jpeg")) return assetPath.replace(/\.jpeg$/, ".jpg");
  if (assetPath.endsWith(".jpg")) return assetPath.replace(/\.jpg$/, ".jpeg");
  return assetPath;
};
